<template>
  <div class="page row">
    <app-title
      :page="'Colour'"
      :prehead="'Nimber Manual'">
      <app-manual-nav slot="content"/>
    </app-title>
    <section class="grid grid-columns-3_sm grid-columns-6_md grid-columns-9_lg">
      <h2 class="grid-column-full">Swatches</h2>
      <h3 class="grid-column-full">Accents</h3>
      <app-swatch :name="'accent'"/>
      <app-swatch :name="'accent2'"/>
      <h3 class="grid-column-full">Grayscale</h3>
      <app-swatch
        :name="'grey-100'"
        :hex="'#FFFFFF'"/>
      <app-swatch
        :name="'grey-150'"
        :hex="'#FFFEFA'"/>
      <app-swatch
        :name="'grey-200'"
        :hex="'#FBFBF6'"/>
      <app-swatch
        :name="'grey-250'"
        :hex="'#EBEBE6'"/>
      <app-swatch
        :name="'grey-300'"
        :hex="'#DCDBD7'"/>
      <app-swatch
        :name="'grey-350'"
        :hex="'#CCCBC8'"/>
      <app-swatch
        :name="'grey-400'"
        :hex="'#BDBCB8'"/>
      <app-swatch
        :name="'grey-450'"
        :hex="'#ADACA9'"/>
      <app-swatch
        :name="'grey-500'"
        :hex="'#9E9C9A'"/>
      <app-swatch
        :name="'grey-550'"
        :hex="'#8F8D8B'"/>
      <app-swatch
        :name="'grey-600'"
        :hex="'#7F7D7B'"/>
      <app-swatch
        :name="'grey-650'"
        :hex="'#706D6C'"/>
      <app-swatch
        :name="'grey-700'"
        :hex="'#605D5D'"/>
      <app-swatch
        :name="'grey-750'"
        :hex="'#514E4D'"/>
      <app-swatch
        :name="'grey-800'"
        :hex="'#413E3E'"/>
      <app-swatch
        :name="'grey-850'"
        :hex="'#322E2F'"/>
      <app-swatch
        :name="'grey-900'"
        :hex="'#221F20'"/>
      <app-swatch
        :name="'grey-950'"
        :hex="'#000000'"/>
      <h3 class="grid-column-full">Light Red</h3>
      <app-swatch
        :name="'light-red-100'"
        :hex="'#FCDBCE'"/>
      <app-swatch
        :name="'light-red-200'"
        :hex="'#FDBBA6'"/>
      <app-swatch
        :name="'light-red-300'"
        :hex="'#FD997D'"/>
      <app-swatch
        :name="'light-red-400'"
        :hex="'#FE7955'"/>
      <app-swatch
        :name="'light-red-500'"
        :hex="'#FF592D'"/>
      <app-swatch
        :name="'light-red-600'"
        :hex="'#D34D2A'"/>
      <app-swatch
        :name="'light-red-700'"
        :hex="'#A74128'"/>
      <app-swatch
        :name="'light-red-800'"
        :hex="'#7A3725'"/>
      <app-swatch
        :name="'light-red-900'"
        :hex="'#4E2B23'"/>
      <h3 class="grid-column-full">Dark Red</h3>
      <app-swatch
        :name="'dark-red-100'"
        :hex="'#E8C9C5'"/>
      <app-swatch
        :name="'dark-red-200'"
        :hex="'#D59794'"/>
      <app-swatch
        :name="'dark-red-300'"
        :hex="'#C06462'"/>
      <app-swatch
        :name="'dark-red-400'"
        :hex="'#AD3231'"/>
      <app-swatch
        :name="'dark-red-500'"
        :hex="'#9A0000'"/>
      <app-swatch
        :name="'dark-red-600'"
        :hex="'#820202'"/>
      <app-swatch
        :name="'dark-red-700'"
        :hex="'#6A0B0C'"/>
      <app-swatch
        :name="'dark-red-800'"
        :hex="'#521313'"/>
      <app-swatch
        :name="'dark-red-900'"
        :hex="'#3A191A'"/>
      <h3 class="grid-column-full">Light Blue</h3>
      <app-swatch
        :name="'light-blue-100'"
        :hex="'#C9ECF5'"/>
      <app-swatch
        :name="'light-blue-200'"
        :hex="'#97DDF4'"/>
      <app-swatch
        :name="'light-blue-300'"
        :hex="'#63CCF1'"/>
      <app-swatch
        :name="'light-blue-400'"
        :hex="'#30BDF0'"/>
      <app-swatch
        :name="'light-blue-500'"
        :hex="'#00AEEF'"/>
      <app-swatch
        :name="'light-blue-600'"
        :hex="'#0091C5'"/>
      <app-swatch
        :name="'light-blue-700'"
        :hex="'#0A749C'"/>
      <app-swatch
        :name="'light-blue-800'"
        :hex="'#135973'"/>
      <app-swatch
        :name="'light-blue-900'"
        :hex="'#1A3C4A'"/>
      <h3 class="grid-column-full">Dark Blue</h3>
      <app-swatch
        :name="'dark-blue-100'"
        :hex="'#C9D3EE'"/>
      <app-swatch
        :name="'dark-blue-200'"
        :hex="'#97ABE6'"/>
      <app-swatch
        :name="'dark-blue-300'"
        :hex="'#6381DE'"/>
      <app-swatch
        :name="'dark-blue-400'"
        :hex="'#3159D6'"/>
      <app-swatch
        :name="'dark-blue-500'"
        :hex="'#0031CE'"/>
      <app-swatch
        :name="'dark-blue-600'"
        :hex="'#002DAB'"/>
      <app-swatch
        :name="'dark-blue-700'"
        :hex="'#0C2989'"/>
      <app-swatch
        :name="'dark-blue-800'"
        :hex="'#132765'"/>
      <app-swatch
        :name="'dark-blue-900'"
        :hex="'#1A2343'"/>
      <h3 class="grid-column-full">Yellow</h3>
      <app-swatch
        :name="'yellow-100'"
        :hex="'#FCEBCB'"/>
      <app-swatch
        :name="'yellow-200'"
        :hex="'#FDDBA0'"/>
      <app-swatch
        :name="'yellow-300'"
        :hex="'#FDCB75'"/>
      <app-swatch
        :name="'yellow-400'"
        :hex="'#FEBB49'"/>
      <app-swatch
        :name="'yellow-500'"
        :hex="'#FFAB1F'"/>
      <app-swatch
        :name="'yellow-600'"
        :hex="'#D38F1E'"/>
      <app-swatch
        :name="'yellow-700'"
        :hex="'#A7731F'"/>
      <app-swatch
        :name="'yellow-800'"
        :hex="'#7A571E'"/>
      <app-swatch
        :name="'yellow-900'"
        :hex="'#4E3B20'"/>
      <h3 class="grid-column-full">Green</h3>
      <app-swatch
        :name="'green-100'"
        :hex="'#CFECCE'"/>
      <app-swatch
        :name="'green-200'"
        :hex="'#A3DEA7'"/>
      <app-swatch
        :name="'green-300'"
        :hex="'#75CE7E'"/>
      <app-swatch
        :name="'green-400'"
        :hex="'#49C057'"/>
      <app-swatch
        :name="'green-500'"
        :hex="'#1DB12F'"/>
      <app-swatch
        :name="'green-600'"
        :hex="'#1E942C'"/>
      <app-swatch
        :name="'green-700'"
        :hex="'#1E7629'"/>
      <app-swatch
        :name="'green-800'"
        :hex="'#205A26'"/>
      <app-swatch
        :name="'green-900'"
        :hex="'#213C23'"/>
    </section>
    <section class="grid grid-columns-2 grid-columns-5_sm">
      <h2 class="grid-column-full">Text colours</h2>
      <div>
        <h3 class="mb2">Accent</h3>
        <p class="accent-text">accent-text</p>
        <p class="accent2-text">accent2-text</p>
      </div>
      <div class="grid grid-columns-2 grid-column-span-2">
        <h3 class="grid-column-full">Grayscale</h3>
        <div>
          <p class="grey-100-text">grey-100-text</p>
          <p class="grey-150-text">grey-150-text</p>
          <p class="grey-200-text">grey-200-text</p>
          <p class="grey-250-text">grey-250-text</p>
          <p class="grey-300-text">grey-300-text</p>
          <p class="grey-350-text">grey-350-text</p>
          <p class="grey-400-text">grey-400-text</p>
          <p class="grey-450-text">grey-450-text</p>
          <p class="grey-500-text">grey-500-text</p>
        </div>
        <div>
          <p class="grey-550-text">grey-550-text</p>
          <p class="grey-600-text">grey-600-text</p>
          <p class="grey-650-text">grey-650-text</p>
          <p class="grey-700-text">grey-700-text</p>
          <p class="grey-750-text">grey-750-text</p>
          <p class="grey-800-text">grey-800-text</p>
          <p class="grey-850-text">grey-850-text</p>
          <p class="grey-900-text">grey-950-text</p>
          <p class="grey-950-text">grey-950-text</p>
        </div>
      </div>
      <div>
        <h3 class="mb2">Light red</h3>
        <p class="light-red-100-text">light-red-100-text</p>
        <p class="light-red-200-text">light-red-200-text</p>
        <p class="light-red-300-text">light-red-300-text</p>
        <p class="light-red-400-text">light-red-400-text</p>
        <p class="light-red-500-text">light-red-500-text</p>
        <p class="light-red-600-text">light-red-600-text</p>
        <p class="light-red-700-text">light-red-700-text</p>
        <p class="light-red-800-text">light-red-800-text</p>
        <p class="light-red-900-text">light-red-900-text</p>
      </div>
      <div>
        <h3 class="mb2">Dark red</h3>
        <p class="dark-red-100-text">dark-red-100-text</p>
        <p class="dark-red-200-text">dark-red-200-text</p>
        <p class="dark-red-300-text">dark-red-300-text</p>
        <p class="dark-red-400-text">dark-red-400-text</p>
        <p class="dark-red-500-text">dark-red-500-text</p>
        <p class="dark-red-600-text">dark-red-600-text</p>
        <p class="dark-red-700-text">dark-red-700-text</p>
        <p class="dark-red-800-text">dark-red-800-text</p>
        <p class="dark-red-900-text">dark-red-900-text</p>
      </div>
      <div>
        <h3 class="mb2">Light blue</h3>
        <p class="light-blue-100-text">light-blue-100-text</p>
        <p class="light-blue-200-text">light-blue-200-text</p>
        <p class="light-blue-300-text">light-blue-300-text</p>
        <p class="light-blue-400-text">light-blue-400-text</p>
        <p class="light-blue-500-text">light-blue-500-text</p>
        <p class="light-blue-600-text">light-blue-600-text</p>
        <p class="light-blue-700-text">light-blue-700-text</p>
        <p class="light-blue-800-text">light-blue-800-text</p>
        <p class="light-blue-900-text">light-blue-900-text</p>
      </div>
      <div>
        <h3 class="mb2">Dark blue</h3>
        <p class="dark-blue-100-text">dark-blue-100-text</p>
        <p class="dark-blue-200-text">dark-blue-200-text</p>
        <p class="dark-blue-300-text">dark-blue-300-text</p>
        <p class="dark-blue-400-text">dark-blue-400-text</p>
        <p class="dark-blue-500-text">dark-blue-500-text</p>
        <p class="dark-blue-600-text">dark-blue-600-text</p>
        <p class="dark-blue-700-text">dark-blue-700-text</p>
        <p class="dark-blue-800-text">dark-blue-800-text</p>
        <p class="dark-blue-900-text">dark-blue-900-text</p>
      </div>
      <div>
        <h3 class="mb2">Yellow</h3>
        <p class="yellow-100-text">yellow-100-text</p>
        <p class="yellow-200-text">yellow-200-text</p>
        <p class="yellow-300-text">yellow-300-text</p>
        <p class="yellow-400-text">yellow-400-text</p>
        <p class="yellow-500-text">yellow-500-text</p>
        <p class="yellow-600-text">yellow-600-text</p>
        <p class="yellow-700-text">yellow-700-text</p>
        <p class="yellow-800-text">yellow-800-text</p>
        <p class="yellow-900-text">yellow-900-text</p>
      </div>
      <div>
        <h3>Green</h3>
        <p class="green-100-text">green-100-text</p>
        <p class="green-200-text">green-200-text</p>
        <p class="green-300-text">green-300-text</p>
        <p class="green-400-text">green-400-text</p>
        <p class="green-500-text">green-500-text</p>
        <p class="green-600-text">green-600-text</p>
        <p class="green-700-text">green-700-text</p>
        <p class="green-800-text">green-800-text</p>
        <p class="green-900-text">green-900-text</p>
      </div>
    </section>
  </div>
</template>

<script>
import Title from '../common/Title'
import ManualNav from './ManualNav'
import Swatch from './components/Swatch'

export default {
  components: {
    appTitle: Title,
    appManualNav: ManualNav,
    appSwatch: Swatch
  }
}
</script>
